import React, { PropsWithChildren } from 'react'
import Drawer, { DrawerProps } from '@mui/material/Drawer'
import Toolbar from '@mui/material/Toolbar'
import CloseIcon from '@mui/icons-material/Close'
import { useViewport } from 'hooks'
import { Box, Button, Text } from 'components'

export type ContentDrawerProps = {
  setDrawer: (open: boolean) => void
  title?: string
  anchor?: "bottom" | "left" | "right" | "top"
} & DrawerProps

type DrawerContainerProps = Pick<ContentDrawerProps, "sx" | "setDrawer" | "anchor" | "variant" | "open" | "title">

const DrawerContainer: React.FC<PropsWithChildren<DrawerContainerProps>> = ({ children, title, open, variant, setDrawer, anchor="right", ...props }) => {
  if (variant === "persistent" && !open) return null

  return <Drawer {...props} anchor={anchor} open={open} variant={variant} onClose={() => setDrawer(false)}>
    <Box sx={(theme) => ({
      borderBottomColor: theme.palette.divider,
      borderBottomStyle: 'solid',
      borderBottomWidth: '1px',
    })}>
      <Toolbar sx={{
        display: 'flex',
        alignItems: 'center',
        px: { xs: 1, sm: 2 }
      }}>
        { title && <Box>
          <Text variant="h6">{ title }</Text>
        </Box> }

        <Box justifySelf="flex-end" ml="auto">
          <Button color="inherit" variant="text" onClick={() => setDrawer(false)} fullWidth={false} sx={{
            px: 0,
            minWidth: 0,
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}>
            <CloseIcon fontSize='large' sx={{ ml: { xs: 0, md: 1 } }} />
          </Button>
        </Box>
      </Toolbar>
    </Box>

    { children }
  </Drawer>
}

export const ContentDrawer: React.FC<PropsWithChildren<ContentDrawerProps>> = (props) => {
  const { isLaptop } = useViewport()

  return <>
    <DrawerContainer {...props} variant={isLaptop ? "persistent" : "temporary"} />
  </>
}

export default ContentDrawer